/**
 * @fileoverview CommonConst const
 */
'use strict';
const CommonConst = {
  /**
   * コンポーネント定義:
   * <ul>
   * <li>BERTH_CATEGORY_LIST
   * </ul>

   * コンポーネント名:
   * <ul>
   * <li>URL
   * <li>PATH
   * </ul>
   * @name COMPONENT
   * @constant
   * @memberOf const.CommonConst
   */
  COMPONENT: {
    MESSAGE: {
      NAME: 'MESSAGE',
      URL: '#application/other/message',
      PATH: 'content/application/other/Message',
      AUTHORITY_ID: ['1', '2', '3', '4', '5']
    },
    MY_PAGE: {
      NAME: 'MY_PAGE',
      URL: '#application/account/mypage',
      PATH: 'content/application/account/MyPage',
      AUTHORITY_ID: ['2', '3', '4', '5']
    },
    REQUEST_DATE_SELECT: {
      NAME: 'REQUEST_DATE_SELECT',
      URL: '#contractor/request/requestdateselect',
      PATH: 'content/contractor/request/RequestDateSelect',
      AUTHORITY_ID: ['4', '5']
    },
    REQUEST_TIME_SELECT: {
      NAME: 'REQUEST_TIME_SELECT',
      URL: '#contractor/request/requesttimeselect',
      PATH: 'content/contractor/request/RequestTimeSelect',
      AUTHORITY_ID: ['4', '5']
    },
    REQUEST_LIST: {
      NAME: 'REQUEST_LIST',
      URL: '#contractor/request/requestlist',
      PATH: 'content/contractor/request/RequestList',
      AUTHORITY_ID: ['4', '5']
    },
    REQUEST_REGIST: {
      NAME: 'REQUEST_REGIST',
      URL: '#contractor/request/requestregist',
      PATH: 'content/contractor/request/RequestRegist',
      AUTHORITY_ID: ['4', '5']
    },
    REQUEST_EDIT: {
      NAME: 'REQUEST_EDIT',
      URL: '#contractor/request/requestedit',
      PATH: 'content/contractor/request/RequestEdit',
      AUTHORITY_ID: ['4', '5']
    },
    REQUEST_CONFIRMATION: {
      NAME: 'REQUEST_CONFIRMATION',
      URL: '#contractor/request/requestconfirmation',
      PATH: 'content/contractor/request/RequestConfirmation',
      AUTHORITY_ID: ['4', '5']
    },
    CENTER_TOP: {
      NAME: 'CENTER_TOP',
      URL: '#center/booking/centertop',
      PATH: 'content/center/booking/CenterTop',
      AUTHORITY_ID: []
    },
    BOOKING_ASSIGN: {
      NAME: 'BOOKING_ASSIGN',
      URL: '#center/booking/bookingassign',
      PATH: 'content/center/booking/BookingAssign',
      AUTHORITY_ID: ['2', '3']
    },
    BOOKING_LIST: {
      NAME: 'BOOKING_LIST',
      URL: '#center/booking/bookinglist',
      PATH: 'content/center/booking/BookingList',
      AUTHORITY_ID: ['2', '3']
    },
    BOOKING_EDIT: {
      NAME: 'BOOKING_EDIT',
      URL: '#center/booking/bookingedit',
      PATH: 'content/center/booking/BookingEdit',
      AUTHORITY_ID: ['2']
    },
    BOOKING_CONFIRMATION: {
      NAME: 'BOOKING_CONFIRMATION',
      URL: '#center/booking/bookingconfirmation',
      PATH: 'content/center/booking/BookingConfirmation',
      AUTHORITY_ID: ['2', '3']
    },
    CONTRACTOR_LIST: {
      NAME: 'CONTRACTOR_LIST',
      URL: '#center/contractor/contractorlist',
      PATH: 'content/center/contractor/ContractorList',
      AUTHORITY_ID: ['2', '3']
    },
    CONTRACTOR_PERMIT: {
      NAME: 'CONTRACTOR_PERMIT',
      URL: '#center/contractor/contractorpermit',
      PATH: 'content/center/contractor/ContractorPermit',
      AUTHORITY_ID: ['2']
    },
    CONTRACTOR_CONFIRMATION: {
      NAME: 'CONTRACTOR_CONFIRMATION',
      URL: '#center/contractor/contractorconfirmation',
      PATH: 'content/center/contractor/ContractorConfirmation',
      AUTHORITY_ID: ['2', '3']
    },
    USER_LIST: {
      NAME: 'USER_LIST',
      URL: '#center/user/userlist',
      PATH: 'content/center/user/UserList',
      AUTHORITY_ID: ['2']
    },
    USER_REGIST: {
      NAME: 'USER_REGIST',
      URL: '#center/user/userregist',
      PATH: 'content/center/user/UserRegist',
      AUTHORITY_ID: ['2']
    },
    USER_EDIT: {
      NAME: 'USER_EDIT',
      URL: '#center/user/useredit',
      PATH: 'content/center/user/UserEdit',
      AUTHORITY_ID: ['2']
    },
    USER_CONFIRMATION: {
      NAME: 'USER_CONFIRMATION',
      URL: '#center/user/userconfirmation',
      PATH: 'content/center/user/UserConfirmation',
      AUTHORITY_ID: ['2']
    },
    BERTH_SETTING: {
      NAME: 'BERTH_SETTING',
      URL: '#center/berth/berthsetting',
      PATH: 'content/center/berth/BerthSetting',
      AUTHORITY_ID: ['2']
    },
    ACCOUNTABLE_TIME_SETTING: {
      NAME: 'ACCOUNTABLE_TIME_SETTING',
      URL: '#center/berth/accountabletimesetting',
      PATH: 'content/center/berth/AccountableTimeSetting',
      AUTHORITY_ID: ['2']
    },
    EXCEPTION_DAY_SETTING: {
      NAME: 'EXCEPTION_DAY_SETTING',
      URL: '#center/berth/exceptiondaysetting',
      PATH: 'content/center/berth/ExceptionDaySetting',
      AUTHORITY_ID: ['2']
    },
    BERTH_CATEGORY_LIST: {
      NAME: 'BERTH_CATEGORY_LIST',
      URL: '#center/berth/berthcategorylist',
      PATH: 'content/center/berth/BerthCategoryList',
      AUTHORITY_ID: ['2']
    },
    BERTH_CATEGORY_REGIST: {
      NAME: 'BERTH_CATEGORY_REGIST',
      URL: '#center/berth/berthcategoryregist',
      PATH: 'content/center/berth/BerthCategoryRegist',
      AUTHORITY_ID: ['2']
    },
    BERTH_CATEGORY_EDIT: {
      NAME: 'BERTH_CATEGORY_EDIT',
      URL: '#center/berth/berthcategoryedit',
      PATH: 'content/center/berth/BerthCategoryEdit',
      AUTHORITY_ID: ['2']
    },
    CENTER_NOTICE_LIST: {
      NAME: 'CENTER_NOTICE_LIST',
      URL: '#center/notice/centernoticelist',
      PATH: 'content/center/notice/CenterNoticeList',
      AUTHORITY_ID: ['2']
    },
    CENTER_NOTICE_REGIST: {
      NAME: 'CENTER_NOTICE_REGIST',
      URL: '#center/notice/centernoticeregist',
      PATH: 'content/center/notice/CenterNoticeRegist',
      AUTHORITY_ID: ['2']
    },
    CENTER_NOTICE_EDIT: {
      NAME: 'CENTER_NOTICE_EDIT',
      URL: '#center/notice/centernoticeedit',
      PATH: 'content/center/notice/CenterNoticeEdit',
      AUTHORITY_ID: ['2']
    },
    BERTH_LIST: {
      NAME: 'BERTH_LIST',
      URL: '#center/berth/berthlist',
      PATH: 'content/center/berth/BerthList',
      AUTHORITY_ID: ['2']
    },
    BERTH_REGIST: {
      NAME: 'BERTH_REGIST',
      URL: '#center/berth/berthregist',
      PATH: 'content/center/berth/BerthRegist',
      AUTHORITY_ID: ['2']
    },
    BERTH_EDIT: {
      NAME: 'BERTH_EDIT',
      URL: '#center/berth/berthedit',
      PATH: 'content/center/berth/BerthEdit',
      AUTHORITY_ID: ['2']
    },
    WORK_TIME: {
      NAME: 'WORK_TIME',
      URL: '#center/berth/worktime',
      PATH: 'content/center/berth/WorkTime',
      AUTHORITY_ID: ['2']
    },
    CAR_MODEL_LIST: {
      NAME: 'CAR_MODEL_LIST',
      URL: '#center/berth/carmodellist',
      PATH: 'content/center/berth/CarModelList',
      AUTHORITY_ID: ['2']
    },
    CAR_MODEL_EDIT: {
      NAME: 'CAR_MODEL_EDIT',
      URL: '#center/berth/carmodeledit',
      PATH: 'content/center/berth/CarModelEdit',
      AUTHORITY_ID: ['2']
    },
    SIGN_DRAWING: {
      NAME: 'SIGN_DRAWING',
      URL: '#center/receptionist/signdrawing',
      PATH: 'content/center/reception/SignDrawing',
      AUTHORITY_ID: ['2', '3']
    },
    RECEPTION_LIST: {
      NAME: 'RECEPTION_LIST',
      URL: '#center/receptionist/receptionlist',
      PATH: 'content/center/reception/ReceptionList',
      AUTHORITY_ID: ['2', '3']
    },
    RECEPTION_EDIT: {
      NAME: 'RECEPTION_EDIT',
      URL: '#center/receptionist/receptionedit',
      PATH: 'content/center/reception/ReceptionEdit',
      AUTHORITY_ID: ['2', '3']
    },
    WORK_RESULT_INPUT: {
      NAME: 'WORK_RESULT_INPUT',
      URL: '#center/receptionist/workresultinput',
      PATH: 'content/center/reception/WorkResultInput',
      AUTHORITY_ID: ['2', '3']
    },
    CONGESTION_SITUATION_LIST: {
      NAME: 'CONGESTION_SITUATION_LIST',
      URL: '#center/receptionist/congestionsituationlist',
      PATH: 'content/center/reception/CongestionSituationList',
      AUTHORITY_ID: ['2', '3', '4', '5']
    },
    ACHIEVEMENT_LIST: {
      NAME: 'ACHIEVEMENT_LIST',
      URL: '#center/receptionist/achievementlist',
      PATH: 'content/center/reception/AchievementList',
      AUTHORITY_ID: ['2', '3']
    },
    FULL_EMPTY_LIST: {
      NAME: 'FULL_EMPTY_LIST',
      URL: '#center/receptionist/fullemptylist',
      PATH: 'content/center/reception/FullEmptyList',
      AUTHORITY_ID: ['2', '3', '4', '5']
    },
    ACHIEVEMENT_EDIT: {
      NAME: 'ACHIEVEMENT_EDIT',
      URL: '#center/receptionist/achievementEdit',
      PATH: 'content/center/reception/AchievementEdit',
      AUTHORITY_ID: ['2', '3']
    }
  },

  /**
   * ログレベル：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL: {
    verbose: 0,
    debug: 1,
    info: 2,
    warning: 3,
    error: 4
  },

  /**
   * ログレベルKey：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL_KEY: ['verbose', 'debug', 'info', 'warning', 'error'],

  /**
   * ログの最大保存件数
   * @name LOG_RECORD_MAX_COUNT
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_RECORD_MAX_COUNT: 1000,

  /**
   * ストレージKey：
   * <ul>
   * <li>ログ
   * <li>権限ID
   * </ul>
   * @name STORAGE_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  STORAGE_KEY: {
    LOG: 'log',
    AUTHORITY_ID: 'authorityId',
    BOOKING_DISPLAY_MODE: 'booking_display_mode',
    IS_KEY_CODE_SETTING: 'isKeyCodeSetting',
    STACKING_PATTERN_LIST: 'stacking_pattern_list',
    CAR_MODEL_LIST: 'car_model_list',
    KEY_LIST: 'key_list',
    BOOKING_ITEM_LIST: 'booking_item_list',
    SYSTEM_SETTING_LIST: 'system_setting_list',
    BOOKING_STATUS_LIST: 'booking_status_list',
    RECEPTION_STATUS_LIST: 'reception_status_list',
    BERTH_CATEGORY_LIST: 'berthCategoryList',
    TOKEN: 'token',
    ACCOUNT_ID: 'accountId',
    TO_SCREEN_NO: 'toScreenNo',
    CENTER_INFO: 'centerInfo',
    SETTING_MEMORY: 'settingMemory',
    SAMPLE_FILE_URL: 'sample_file_url',
    SUB_STATUS_LIST: 'sub_status_list',
    ITEM_NAME: 'item_list',
    DELIVERY_LIST: 'delivery_list',
    TEL: 'tel',
    PERFORMANCE_OPTION: 'performance_option',
    AVAILABLE_INFO_RELOAD_SECONDS: 'available_info_reload_seconds',
    BOOKING_DELAY_OPTION: 'booking_delay_option',
    ENQUETE_OPTION: 'is_enquete_option',
    THERMOMETER_OPTION: 'is_thermometer_option'
  },

  /**
   * 保存するセンター設定
   * @name THEME
   * @constant
   * @memberOf const.CommonConst
   */
  SAVE_CENTER_SETTIING: [
    'booking_item_list',
    'stacking_pattern_list',
    'key_list',
    'car_model_list',
    'sub_status_list',
    'reception_status_list',
    'booking_status_list',
    'system_setting_list',
    'item_list',
    'delivery_list'
  ],

  /**
   * テーマ
   * @name THEME
   * @constant
   * @memberOf const.CommonConst
   */
  THEME: 'windows',

  /**
   * タイムアウト時間
   * <ul>
   * <li>デフォルト
   * </ul>
   * @name TIMEOUT
   * @constant
   * @memberOf const.CommonConst
   */
  TIMEOUT: {
    DEFAULT: 30000,
    CALLING: 90000
  },

  /**
   * REST API一覧
   * @name API_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  API_LIST: {
    A02: '/portal/logout',
    A06: '/portal/account/edit',
    A07: '/portal/account/detail',
    A08: '/portal/contractor/addcenter',
    A09: '/portal/contractor/delcenter',
    A10: '/portal/contractor',
    A11: '/portal/contractor/detail',
    A13: '/portal/driver',
    A20: '/portal/car',
    A27: '/portal/notice',
    A28: '/portal/notice/regist',
    A29: '/portal/notice/edit',
    A30: '/portal/notice/delete',
    A31: '/portal/transporter',
    A32: '/center/booking',
    A33: '/center/booking/regist',
    A34: '/center/booking/edit',
    A35: '/center/booking/fileUpload',
    A36: '/center/booking/fileDelete',
    A37: '/center/booking/export',
    A38: '/center/booking/contractor',
    A39: '/center/booking/dayStatus',
    A40: '/center/booking/timeStatus',
    A41: '/center/booking/assign',
    A42: '/center/booking/assignEdit',
    A43: '/center/booking/resultRegist',
    A44: '/center/booking/noAssign',
    A45: '/center/booking/latest',
    A46: '/center/user',
    A47: '/center/user/regist',
    A48: '/center/user/edit',
    A49: '/center/user/delete',
    A51: '/center/berthCategory',
    A52: '/center/berthCategory/delete',
    A53: '/center/berthCategory/basicRegist',
    A54: '/center/berthCategory/basicUpdate',
    A55: '/center/berthCategory/availableDay',
    A56: '/center/berthCategory/availableDayEdit',
    A57: '/center/berthCategory/exceptionDay',
    A58: '/center/berthCategory/bulkExceptionEdit',
    A59: '/center/berth',
    A60: '/center/berth/regist',
    A61: '/center/berth/bulcRegist',
    A62: '/center/berth/edit',
    A63: '/center/berth/delete',
    A64: '/center/carModel',
    A65: '/center/carModel',
    A66: '/center/carModel/edit',
    A67: '/center/carModel',
    A68: '/center/carModel',
    A69: '/center/workingTime',
    A73: '/center/setting',
    A75: '/center/user/detail',
    A76: '/center/carModel/detail',
    A77: '/center/berth/detail',
    A78: '/center/booking/workTime',
    A79: '/center/booking/detail',
    A80: '/center/berthCategory/detail',
    A81: '/center/booking/delete',
    A82: '/center/berthCategory/exceptionDayExport',
    A83: '/portal/notice/detail',
    A100: '/center/blob/getCsvUploadUrl',
    A101: '/center/blob/getFileUploadUrl',
    A110: '/center/reception/sign/regist',
    A111: '/center/reception',
    A112: '/center/reception/detail',
    A113: '/center/reception/calling',
    A114: '/center/performance',
    A115: '/center/reception/statusUpdate',
    A116: '/center/reception/export',
    A117: '/center/reception/busyStatus',
    A118: '/center/performance/export',
    A120: '/portal/account/driver/detail',
    A121: '/portal/account/driver/edit/web',
    A122: '/center/booking/driver',
    A123: '/center/performance/available',
    A124: '/center/performance/detail',
    A125: '/center/performance/edit',
    A126: '/center/reception/edit'
  },

  /**
   * HTTPステータスコードリスト
   * <ul>
   * <li>401
   * </ul>
   * @name HTTP_STATUS_CODE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  HTTP_STATUS_CODE_LIST: {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401
  },

  /**
   * 曜日リスト
   * <ul>
   * <li>月
   * <li>火
   * <li>水
   * <li>木
   * <li>金
   * <li>土
   * <li>日
   * </ul>
   * @name WEEK_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  WEEK_LIST: ['1', '2', '3', '4', '5', '6', '0'],

  /**
   * 入力値の最大文字数リスト
   * <ul>
   * <li>50
   * </ul>
   * @name INPUT_MAX_LENGTH_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  INPUT_MAX_LENGTH_LIST: {
    MAX_1: 1,
    MAX_2: 2,
    MAX_3: 3,
    MAX_4: 4,
    MAX_7: 7,
    MAX_8: 8,
    MAX_11: 11,
    MAX_20: 20,
    MAX_32: 32,
    MAX_50: 50,
    MAX_128: 128,
    MAX_255: 255,
    MAX_256: 256,
    MAX_4000: 4000
  },

  /**
   * 権限リスト
   * <ul>
   * <li>システム管理者
   * <li>センター管理者
   * <li>バース作業員
   * <li>配送業者
   * <li>ドライバー
   * </ul>
   * @name AUTHORITY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  AUTHORITY_LIST: {
    SYSTEM_MANAGER: '1',
    CENTER_MANAGER: '2',
    BERTH_WORKER: '3',
    CONTRACTOR: '4',
    DRIVER: '5'
  },

  /**
   * ポータルサイトのURLリスト
   * <ul>
   * <li>ホーム
   * <li>車両管理
   * <li>ドライバー管理
   * </ul>
   * @name PORTAL_URL_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  PORTAL_URL_LIST: {
    LOGIN: '/#application/authentication/login',
    HOME: '/#contractor/portal/portaltop',
    CAR: '/#contractor/car/carlist',
    DRIVER: '/#contractor/driver/driverlist'
  },

  /**
   *予約状況画面表示モード
   * <ul>
   * <li>予約日選択
   * <li>予約時間選択
   * </ul>
   * @name PORTAL_URL_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  BOOKING_DISPLAY_MODE_LIST: {
    CALENDAR: 'calendar',
    TIME: 'time'
  },

  /**
   * 正規表現パターン
   * @name REGULAR_EXPRESSION_PATTERN
   * @constant
   * @memberOf const.CommonConst
   */
  REGULAR_EXPRESSION_PATTERN: {
    /** 半角英数字 */
    P001: /^[a-zA-Z0-9]+$/,
    /** true or false */
    P002: /true|false/,
    /** 半角数字(整数) */
    P003: /^\d*$/,
    /** 0-3(整数) */
    P004: /^[0-3]$/,
    /** 半角英数記号 */
    P005: /^[\x20-\x7e]*$/,
    /** メールアドレス */
    P006: /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    /** 全角 */
    P007: /^[^\x20-\x7e]*$/,
    /** ひらがな */
    P008: /^[\u3040-\u309f]+$/,
    /** ひらがな(伸ばし棒あり) */
    P009: /^[\u3040-\u309f\u30fc]+$/,
    /** 電話番号 */
    P010: /^0[0-9]*$/,
    /** 分類番号 */
    P011: /^[A-Z0-9]+$/,
    /** ログインID */
    P012: /^[\x21-\x7e]*$/,
    /** 企業コード */
    P013: /^[a-z0-9\-\\_]{3,20}$/,
    /** 端末コード */
    P014: /^[a-z0-9\-\\_]{1,7}$/,
    /** 測定値 整数部 2桁*/
    P015: /^[1-9][0-9]$/,
    /** 測定値 小数部 1桁*/
    P016: /^[0-9]$/
  },

  /**
   * moment.js 日付単位キー
   * @name MOMENT_KEYS
   * @constant
   * @memberOf const.CommonConst
   */
  MOMENT_KEYS: {
    YEARS: 'y',
    MONTHS: 'M',
    DAYS: 'd',
    HOUR: 'h',
    MINUTES: 'm'
  },

  /**
   * 一覧画面テーブル最大行数
   * @name LIST_TABLE_MAX_ROW
   * @constant
   * @memberOf const.CommonConst
   */
  LIST_TABLE_MAX_ROW: 10,

  /**
   * 予約登録アップロードファイルのアップロード数
   * @name UPLOAD_FILE_COUNT_MAX
   * @constant
   * @memberOf const.CommonConst
   */
  UPLOAD_FILE_COUNT_MAX: 5,

  /**
   * 予約登録ドライバーメールアドレス数
   * @name MAIL_ADDRESS_COUNT_MAX
   * @constant
   * @memberOf const.CommonConst
   */
  MAIL_ADDRESS_COUNT_MAX: 5,

  /**
   * ファイル拡張子
   * @name FILE_NAME_EXTENSION
   * @constant
   * @memberOf const.CommonConst
   */
  FILE_NAME_EXTENSION: {
    CSV: 'csv'
  },

  /**
   * リクエストヘッダーキー
   * @name REQUEST_HEADER_KEYS
   * @constant
   * @memberOf const.CommonConst
   */
  REQUEST_HEADER_KEYS: {
    X_LOGIPULL_TOKEN: 'X-LogiPullToken'
  },

  /**
   * 予約項目キーリスト
   * @name BOOKING_ITEM_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  BOOKING_ITEM_KEY_LIST: {
    CONTRACTOR_ID: 'contractor_id',
    BERTH_CATEGORY_ID: 'berth_category_id',
    BOOKING_STATUS_ID: 'booking_status_id',
    STACKING_PATTERN_ID: 'stacking_pattern_id',
    KEY_CODE: 'key_code',
    HAVE_WINGS: 'have_wings',
    CAR_MODEL_NAME: 'car_model_name',
    OCCUPANCE_BERTH: 'occupancy_berth',
    CAR_NO: 'car_no',
    TRANSPORTER_NAME: 'transporter_name',
    DRIVER_NAME: 'driver_name',
    DRIVER_TEL: 'driver_tel',
    BOOKING_ON: 'booking_on',
    START_TIME: 'start_time',
    END_TIME: 'end_time',
    NOTE: 'note',
    OPTION1: 'option_1',
    OPTION2: 'option_2',
    OPTION3: 'option_3',
    OPTION4: 'option_4',
    OPTION5: 'option_5',
    MAIL_ADDRESS: 'mail_address',
    BOOKING_DOCUMENT: 'booking_document',
    DELIVERY_NAME: 'delivery_name',
    ITEM_NAME: 'item_name'
  },

  /**
   * 受付項目キーリスト
   * @name RECEPTION_ITEM_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  RECEPTION_ITEM_KEY_LIST: {
    RECEPTION_AT: 'reception_at',
    IS_AUTO_RECEPTION: 'is_auto_reception',
    RECEPTION_DOCUMENT: 'reception_document'
  },

  /**
   * クエリパラメータのキーリスト
   * @name QUERY_PARAMETER_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  QUERY_PARAMETER_KEY_LIST: {
    QUESTION_MARK: '?',
    EQUAL: '=',
    AND: '&',
    PERIOD: '.',
    ID: 'id',
    STATUS: 'status',
    RESULT: 'result',
    SUB_STATUS: 'subStatus'
  },

  /**
   * エラーエリアのスタイル
   * @name ERROR_AREA_STYLE
   * @constant
   * @memberOf const.CommonConst
   */
  ERROR_AREA_STYLE: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger'
  },

  /**
   * ファイルの合計最大サイズ(byte)
   * @name FILE_TOTAL_MAX_SIZE
   * @constant
   * @memberOf const.CommonConst
   */
  FILE_TOTAL_MAX_SIZE: 5242880,

  /**
   * 設定情報キーリスト
   * @name SETTING_MEMORY_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_KEY_LIST: {
    START_DAY: 'startDay',
    END_DAY: 'endDay',
    BOOKING_STATUS_ID: 'bookingStatusId',
    BERTH_CATEGORY_ID: 'berthCategoryId',
    KEY_CODE: 'keyCode',
    BOOKING_ON: 'bookingOn',
    START_TIME: 'startTime',
    CONTRACTOR_NAME: 'contractorName',
    USE_STATUS: 'useStatus',
    USER_NAME: 'userName',
    STATUS: 'status',
    TARGET_DATE: 'targetDate',
    END_TIME: 'endTime',
    BERTH_CATEGORY_LIST: 'berthCategoryList',
    RECEPTION_STATUS_LIST: 'receptionStatusList',
    SUB_STATUS: 'subStatus',
    DELIVERY_NAME: 'deriveryName',
    TRANSPORTER_NAME: 'transporterName',
    NOTE: 'note'
  },

  /**
   * 設定情報初期値
   * @name SETTING_MEMORY_DEFAULT
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_DEFAULT: {
    REQUEST_TIME_SELECT: {
      bookingOn: '',
      keyCode: ''
    },
    REQUEST_DATE_SELECT: {
      bookingOn: '',
      keyCode: ''
    },
    REQUEST_LIST: {
      startDay: '',
      endDay: '',
      bookingStatusId: '',
      berthCategoryId: '',
      keyCode: ''
    },
    REQUEST_REGIST: {
      bookingOn: '',
      startTime: '',
      berthCategoryId: '',
      keyCode: ''
    },
    BOOKING_ASSIGN: {
      bookingOn: '',
      berthCategoryId: ''
    },
    CONTRACTOR_LIST: {
      contractorName: '',
      useStatus: ''
    },
    USER_LIST: {
      userName: ''
    },
    BERTH_LIST: {
      berthCategoryId: ''
    },
    CAR_MODEL_LIST: {
      berthCategoryId: ''
    },
    CENTER_NOTICE_LIST: {
      status: ''
    },
    RECEPTION_LIST: {
      targetDate: '',
      startTime: '',
      endTime: '',
      berthCategoryList: [],
      receptionStatusList: []
    },
    ACHIEVEMENT_LIST: {
      startDay: '',
      endDay: '',
      berthCategoryList: [],
      workResultList: [],
      deliveryName: '',
      transporterName: '',
      note: ''
    }
  },

  /**
   * アカウント編集結果
   * <ul>
   * <li>成功
   * <li>ユーザーID重複
   * <li>旧パスワード誤り
   * <li>その他
   * </ul>
   * @name ACCOUNT_REGIST_RESULT
   * @constant
   * @memberOf const.CommonConst
   */
  ACCOUNT_EDIT_RESULT: {
    SUCCESS: '1',
    USER_ID_DUPLICATE: '2',
    OLD_PASSWORD_ERROR: '3',
    OTHER: '9'
  },

  /**
   * センター遷移画面
   * <ul>
   * <li>予約一覧
   * <li>予約日時選択
   * <li>混雑状況一覧
   * </ul>
   * @name CENTER_SCREEN
   * @constant
   * @memberOf const.CommonConst
   */
  CENTER_SCREEN: {
    REQUEST_LIST: '1',
    REQUEST_DATE_AND_TIME_SELECT: '2',
    CONGESTION_SITUATION_LIST: '3'
  },

  /**
   * スマホ対応
   * 選択種別
   * @name SELECT_TYPE
   * @constant
   * @memberOf const.CommonConst
   */
  SELECT_TYPE: {
    /** 単一選択 */
    SINGLE: 'single',
    /** 複数選択 */
    MULTIPLE: 'multiple'
  }
};
export default CommonConst;



// WEBPACK FOOTER //
// ./src/js/const/CommonConst.jsx